(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolong-game/assets/javascripts/components/gamedates-info.js') >= 0) return;  svs.modules.push('/components/numbergames/prolong-game/assets/javascripts/components/gamedates-info.js');

'use strict';

const {
  useRef,
  useEffect,
  useContext
} = React;
const {
  PROLONG_SUBSCRIPTION
} = svs.numbergames.prolong_game.common.constants;
const {
  ProlongContext
} = svs.numbergames.prolong_game.context;
const animateShowHide = el => ({
  show: () => {
    el.style.height = "".concat(el.scrollHeight, "px");
    el.classList.remove('hidden');
    el.classList.add('visible');
  },
  hide: () => {
    el.style.height = '0';
    el.classList.remove('visible');
    el.classList.add('hidden');
  }
});
const getGameDateText = (product, selectedDays, drawCount) => svs.numbergames.draws.drawsUtils.drawDateText(selectedDays, {
  productId: svs.numbergames.productMapping.getProductId(product),
  selectedDays,
  drawCount
});
const GameDatesInfo = () => {
  const elRef = useRef(null);
  const {
    selectedDays,
    drawCount,
    wager: {
      productName
    }
  } = useContext(ProlongContext);
  const gameDatesText = getGameDateText(productName, selectedDays, drawCount);
  useEffect(() => {
    const el = elRef.current;
    const animate = animateShowHide(el);
    if (drawCount === PROLONG_SUBSCRIPTION) {
      animate.show();
    } else {
      animate.hide();
    }
  }, [drawCount]);
  return React.createElement("div", {
    className: "gamedates-info u-text-center padding-top padding-bottom"
  }, React.createElement("div", {
    className: "margin-bottom"
  }, gameDatesText, "\xA0"), React.createElement("div", {
    ref: elRef
  }, drawCount === PROLONG_SUBSCRIPTION && React.createElement("div", {
    className: "margin-bottom"
  }, "Prenumerationen har ingen bindningstid och betalas m\xE5nadsvis med bankkort eller autogiro.")));
};
setGlobal('svs.numbergames.prolong_game.components.GameDatesInfo', GameDatesInfo);

 })(window);